export interface Project {
  projectId: string;
  isPinned: boolean;
  projectName: string;
  projectCode: string;
  projectStatus: string;
  clientPreferredId: string;
  projectDescription: string;
  overseeingAttorneys: string;
  overseeingAttorneysEmail: string;
  clientUniqueProjectId: string;
  clientBranch?: ClientBranch;
  clientOrganization?: ClientOrganization;
  clientDepartment?: ClientDepartment;
  workspaces: Workspace[];
  branches?: any[];
  departments?: any[];
  entities?: any[];
  highlyConfidential?: boolean;
  entityName?: string;
  ecaEnabled?: boolean;
  nlpSearchEnabled?: boolean;
  projectAlphaCode?: string;
  dataCenterName?: string;
  domainCountryCode?: string;
  countryName?: string;
  userAlertCount?: number;
  isNonConsilioWorkflow?: boolean;
  attorneysAdditionalContactInfo?: string;
  budgetConsumptionEnabled?: boolean;
  auroraType?: string;
  isRecentlyAdded?: boolean;
  createdOn?: string;
  isUploadEvidenceSourcePending?: boolean;
  internalProjectName?: string;
}

export interface drpData {
  branches: drpDataItem[];
  departments: drpDataItem[];
  entities: drpDataItem[];
}

interface drpDataItem {
  id: string;
  name: string;
}
interface ClientBranch {
  id: string;
  name: string;
  isSelected: boolean;
}

interface ClientDepartment {
  id: string;
  name: string;
  isSelected: boolean;
}

interface ClientOrganization {
  id: string;
  name: string;
  isSelected: boolean;
}

export interface Workspace {
  workspaceId: string;
  name: string;
  workspaceCode: string;
  projectId: string;
  statusType: string;
  instanceId: string;
  artifactID: string;
  workspaceUserAlertCount?: number;
  userHasAccess: boolean;
}

export enum ProjectStatus {
  closed = 'Closed',
  pending = 'Pending',
  new = 'New',
}

export enum WorkspaceStatus {
  closed = 'Closed',
}
